
  import { mapState } from 'vuex'
  export default {
    name: 'Theme5SideMenu',
    data() {
      return {
        model: false
      }
    },
    computed: {
      message() {
        return this.$store.state.player.messages
      },
      ...mapState({
        operationSetting: state => state.settings.operationSetting,
        isLogin: state => state.settings.isLogin
      }),
      infoItems() {
        return [
          {
            icon: 'mdi-cash-minus',
            text: this.tl('withdrawal'),
            key: 'withdrawal',
            to: '/player/withdrawals'
          },
          {
            icon: 'mdi-hand-extended-outline',
            text: this.tl('cashier'),
            key: 'cashier',
            to: '/cashier'
          },
          {
            icon: 'mdi-gift-outline',
            text: this.tl('myBonus'),
            key: 'myBonus',
            to: '/my-bonus?tab=0'
          },
          {
            icon: 'mdi-account',
            text: this.tl('myProfile'),
            key: 'profile',
            to: '/player/profile'
          },
          {
            icon: 'mdi-message-text-outline',
            text: this.tl('message'),
            key: 'message',
            to: '/player/messages'
          },
          {
            icon: 'mdi-bank',
            text: this.operationSettingCheckCrypto
              ? this.tl('walletDetail')
              : this.tl('bankDetail'),
            key: 'bank-details',
            to: '/payment-methods'
          },

          {
            icon: 'mdi-history',
            text: this.tl('history'),
            key: 'history',
            to: '/history/transaction'
          }
        ]
      }
    }
  }
